import React from 'react';
import PropTypes from 'prop-types';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import VerticalBookCard from 'rebook/apps/books/components/VerticalBookCard';
import FakeVerticalBookCard from 'rebook/apps/books/components/FakeVerticalBookCard';
import VerticalBookCardEmpty from 'rebook/apps/books/components/VerticalBookCardEmpty';

import styles from './style.scss';


const BookItems = ({ bookList, activeBook, shouldShowBookOrder }) => {
  return bookList.map((object) => {
    const book = object.book ? object.book : object;
    if (book.type === 'fake') {
      return (
        <FakeVerticalBookCard
          text="Найдите&#10;ещё книг"
          key={object.id}
          url="/reco/" />
      );
    }

    const order = object.order && shouldShowBookOrder ? object.order : null;
    const isActiveItem = activeBook
      ? object.book.id === activeBook.id
      : false;

    return (
      <VerticalBookCard
        key={object.id}
        isActiveItem={isActiveItem}
        order={order}
        book={book} />
    );
  });
};

const VerticalBookCardList = ({ bookList, activeBook, shouldShowBookOrder, ...sliderSettings }) => (
  <React.Fragment>
    {bookList && bookList.length !== 0
      ? (
        <ContentCarousel {...sliderSettings}>
          {BookItems({ bookList, activeBook, shouldShowBookOrder })}
        </ContentCarousel>
      )
      : (
        <div className={styles.emptyBookList}>
          {[...Array(10)].map((item, key) => (
            <VerticalBookCardEmpty key={key} />
          ))}
        </div>
      )
    }
  </React.Fragment>
);

VerticalBookCardList.propTypes = {
  bookList: PropTypes.arrayOf(PropTypes.shape({
    book: PropTypes.object,
    order: PropTypes.number,
  })),
  activeBook: PropTypes.object,
  shouldShowBookOrder: PropTypes.bool,
};

VerticalBookCardList.defaultProps = {
  shouldShowBookOrder: false,
};

export default VerticalBookCardList;
